import React, { useState, useEffect } from "react";
import { Button, Empty, Select } from "antd";

import moment from "moment";
import dayjs from 'dayjs';
import { Card, Col, Row, Tooltip, DatePicker, Tabs, Table, Typography } from "antd";
import { CSVLink } from 'react-csv'
import ColumnChart from "../charts/ColumnChart";
import DoughNutChart from "../charts/DoughnutChart";
import FunnelChart from "../charts/FunnelChart";
import PieChart from "../charts/PieChart";
import StackColumnChart from "../charts/StackColumnChart";
import CitizenScienceProvinceMap from "../charts/CitizenScienceProvinceMap";
import CitizenScienceDistrictMap from "../charts/CitizenScienceDistrictMap";

import Legend from "../charts/Legend";
import { util } from "../../utils/functions/custom";

import "antd/dist/reset.css";
import { InfoCircleTwoTone } from "@ant-design/icons";

import citizenScienceAPI from "../../services/citizenScienceAnalyticsService";
import commonLookupAPI from "../../services/commonLookupService";
import { ReportTemplate } from "../custom/ReportTemplate";
import { ReportButtons } from "../custom/ReportButtons";
import { reportTypeEnum } from "../custom/AppEnums";
import EventsMap from "../charts/EventsMap";
import StackAreaChart from "../charts/StackAreaChart";
import HeatMapChart from "../charts/HeatMapChart";
import { registerIconFonts } from "@ant-design/charts";
import BarChart from "../charts/BarChart";
import { ReportTemplatePartner } from "../custom/ReportTemplatePartner";
import { recordError } from "src/utils/logService";
import { DownloadDataAsExcel } from "../custom";

export const CitizenScienceReport = (props) => {
  const { filterType } = props;
  const { Text } = Typography;

  const [initialised, setInitialised] = useState(false);
  const [rolesDuringData, setRolesDuringData] = useState([]);
  const [rolesPostData, setRolesPostData] = useState([]);
  const [rolesConceptualisation, setRolesConceptualisation] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [scienceEngagement, setScienceEngagement] = useState([]);

  const [projectPartnerRoles, setProjectPartnerRoles] = useState([]);
  const [projectPartnerObjectives, setProjectPartnerObjectives] = useState([]);
  const [projectPartnerContributions, setProjectPartnerContributions] =
    useState([]);
  const [projectPartnerResearch, setProjectPartnerResearch] = useState([]);
  const [projectDomainFields, setProjectDomainFields] = useState([]);

  const [scienceShops, setScienceShops] = useState([]);

  const [fundingSources, setFundingSources] = useState([]);

  const [ageRangeData, setAgeRangeData] = useState([]);
  const [participantTypeData, setParticipantTypeData] = useState([]);

  const [raceData, setRaceData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [disabilityData, setDisabilityData] = useState([]);

  const [provincialProjectData, setProvincialProjectData] = useState([]);
  const [municipalProjectData, setMunicipalProjectData] = useState([]);

  const [provincialParticipationData, setProvincialParticipationData] =
    useState([]);
  const [municipalParticipationData, setMunicipalParticipationData] = useState(
    []
  );

  const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());
  const [financialYears, setFinancialYears] = useState(
    util.getCurrentFinancialYear()
  );
  // const [currentDate, setcurrentDate] = useState(dayjs(Date()));
  // const [startDate, setStartDate] = useState();
  // const [endDate, setEndDate] = useState();

  const [filterId, setFilterId] = useState(-1);
  const [show, setShow] = useState(false);
  const [isGeo, setIsGeo] = useState(false);
  const [isFunnel, setIsFunnel] = useState(false);

  const [scienceFields, setScienceFields] = useState([]);
  const [scienceDomains, setScienceDomains] = useState([]);
  const [scienceFieldName, setScienceFieldName] = useState("Science Fields");

  const [csvData, setCsvData] = useState([]);
  const [initialKey, setInitialKey] = useState();
  const [organisationalTotalProjects, setOrganisationalTotalProjects] =
    useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [firstRecord, setFirstRecord] = useState(0);

  const [reportOutProps, setReportOutProps] = useState({
    data: [],
    color: "",
    type: "",
    year: 0,
    description: "",
    xLabel: "",
    yLabel: "",
  });

  const { Option } = Select;
  const projectsProvincialDistribution = "Distribution of Projects by Province";
  const projectsMunicialDistribution =
    "Distribution of Projects by Municipal District";
  const projectsProvincialParticipation =
    "Distribution of Citizen Scientist by Province";
  const projectsMunicipalParticipation =
    "Distribution of Citizen Scientist by Municipal District";

  useEffect(() => {
    if (!initialised) {
      setFinancialYears(util.getCurrentFinancialYear());
      util.getYearsWithReports(
        citizenScienceAPI,
        setFinancialYears,
        setReportYear
      );
      // getScienceFields();
      setInitialised(true);
    }
    initiateReportData(reportYear);
  }, [filterType, reportYear]);

  const initiateReportData = (repYear) => {
    getProjectProvincial(repYear);
    getProjectMunicipal(repYear);
    getParticipationProvincial(repYear);
    getParticipationMunicipal(repYear);
    getParticipantsRolesDuring(repYear);
    getParticipantsRolesPost(repYear);
    getParticipantsConceptRoles(repYear);
    getParticipantsDemographicAgeRange(repYear);
    getParticipantsDemographicsDisability(repYear);
    getParticipantsDemographicsRace(repYear);
    getParticipantsDemographicsGender(repYear);
    getParticipantsTypeDemographic(repYear);
  };

  const getScienceFields = async () => {
    try {
      const response = await commonLookupAPI.getScienceFields();
      if (response && response.status === 200) {
        const { data } = response;
        if (data.length > 0) {
          setScienceFieldName("Science field - " + data[0].value);
          getScienceDomainData(reportYear, data[0].key);
        }
        setScienceFields(data);
      } else {
        setScienceFields([]);
      }
    } catch (error) {
      setScienceFields([]);
      recordError(error);
    }
  };

  const getScienceObjectives = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getScienceObjectives(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setObjectives(data);
      } else {
        setObjectives([]);
      }
    } catch (error) {
      setObjectives([]);
      recordError(error);
    }
  };

  const getScienceEngagements = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getScienceEngagements(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setScienceEngagement(data);
      } else {
        setScienceEngagement([]);
      }
    } catch (error) {
      setScienceEngagement([]);
      recordError(error);
    }
  };

  const getProjectPartnerObjectives = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectPartnerObjectives(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProjectPartnerObjectives(data);
      } else {
        setProjectPartnerObjectives([]);
      }
    } catch (error) {
      setProjectPartnerObjectives([]);
      recordError(error);
    }
  };

  const getProjectPartnerRole = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectPartnerRole(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProjectPartnerRoles(data);
      } else {
        setProjectPartnerRoles([]);
      }
    } catch (error) {
      setProjectPartnerRoles([]);
      recordError(error);
    }
  };

  const getProjectPartnerContributions = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectPartnerContributions(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProjectPartnerContributions(data);
      } else {
        setProjectPartnerContributions([]);
      }
    } catch (error) {
      setProjectPartnerContributions([]);
      recordError(error);
    }
  };

  const getProjectPartnerResearch = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectPartnerResearch(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProjectPartnerResearch(data);
      } else {
        setProjectPartnerResearch([]);
      }
    } catch (error) {
      setProjectPartnerResearch([]);
      recordError(error);
    }
  };

  const getProjectScienceShop = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectScienceShop(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setScienceShops(data);
      } else {
        setScienceShops([]);
      }
    } catch (error) {
      setScienceShops([]);
      recordError(error);
    }
  };

  const getParticipantsRolesDuring = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipantsRolesDuring(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setRolesDuringData(data);
      } else {
        setRolesDuringData([]);
      }
    } catch (error) {
      setRolesDuringData([]);
      recordError(error);
    }
  };

  const getParticipantsRolesPost = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipantsRolesPost(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setRolesPostData(data);
      } else {
        setRolesPostData([]);
      }
    } catch (error) {
      setRolesPostData([]);
      recordError(error);
    }
  };

  const getParticipantsConceptRoles = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipantsConceptRoles(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setRolesConceptualisation(data);
      } else {
        setRolesConceptualisation([]);
      }
    } catch (error) {
      setRolesConceptualisation([]);
      recordError(error);
    }
  };

  const getParticipantsDemographicsDisability = async (year, filterId) => {
    try {
      const response =
        await citizenScienceAPI.getParticipantsDemographicsDisability(
          year,
          filterId,
          filterType
        );
      if (response && response.status === 200) {
        const { data } = response;
        setDisabilityData(data);
      } else {
        setDisabilityData([]);
      }
    } catch (error) {
      setDisabilityData([]);
      recordError(error);
    }
  };

  const getParticipantsDemographicsGender = async (year, filterId) => {
    try {
      const response =
        await citizenScienceAPI.getParticipantsDemographicsGender(
          year,
          filterId,
          filterType
        );
      if (response && response.status === 200) {
        const { data } = response;
        setGenderData(data);
      } else {
        setGenderData([]);
      }
    } catch (error) {
      setGenderData([]);
      recordError(error);
    }
  };

  const getParticipantsDemographicsRace = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipantsDemographicsRace(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setRaceData(data);
      } else {
        setRaceData([]);
      }
    } catch (error) {
      setRaceData([]);
      recordError(error);
    }
  };

  const getParticipantsDemographicAgeRange = async (year, filterId) => {
    try {
      const response =
        await citizenScienceAPI.getParticipantsDemographicsAgeRange(
          year,
          filterId,
          "age-range"
        );
      if (response && response.status === 200) {
        const { data } = response;
        setAgeRangeData(data);
      } else {
        setAgeRangeData([]);
      }
    } catch (error) {
      setAgeRangeData([]);
      recordError(error);
    }
  };

  const getParticipantsTypeDemographic = async (year, filterId) => {
    try {
      const response =
        await citizenScienceAPI.getParticipantsDemographicsAgeRange(
          year,
          filterId,
          "type"
        );
      if (response && response.status === 200) {
        const { data } = response;
        setParticipantTypeData(data);
      } else {
        setParticipantTypeData([]);
      }
    } catch (error) {
      setParticipantTypeData([]);
      recordError(error);
    }
  };

  const getProjectProvincial = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectLocationProvince(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProvincialProjectData(data);
      } else {
        setProvincialProjectData([]);
      }
    } catch (error) {
      setProvincialProjectData([]);
      recordError(error);
    }
  };

  const getProjectMunicipal = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getProjectLocationMunicipal(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setMunicipalProjectData(data);
      } else {
        setMunicipalProjectData([]);
      }
    } catch (error) {
      setMunicipalProjectData([]);
      recordError(error);
    }
  };

  const getParticipationProvincial = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipationProvince(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setProvincialParticipationData(data);
      } else {
        setProvincialParticipationData([]);
      }
    } catch (error) {
      setProvincialParticipationData([]);
      recordError(error);
    }
  };

  const getParticipationMunicipal = async (year, filterId) => {
    try {
      const response = await citizenScienceAPI.getParticipationMunicipal(
        year,
        filterId,
        filterType
      );
      if (response && response.status === 200) {
        const { data } = response;
        setMunicipalParticipationData(data);
      } else {
        setMunicipalParticipationData([]);
      }
    } catch (error) {
      setMunicipalParticipationData([]);
      recordError(error);
    }
  };

  const getOrganisationalTotalProject = async (year, hostPartnerId) => {
    try {
      const response = await citizenScienceAPI.getOrganisationalTotalProject(
        year,
        hostPartnerId
      );
      if (response && response.status === 200) {
        const { data } = response;
        if (data.length > 0) {
          setInitialKey(data[0].key);
        }
        setOrganisationalTotalProjects(data);
      } else {
        setOrganisationalTotalProjects([]);
      }
    } catch (error) {
      setOrganisationalTotalProjects([]);
      recordError(error);
    }
  };

  // const updateAnalytics = (repYear, filterId) => {

  //   getProjectDomainFields(repYear);
  //   getParticipantsConceptRoles(repYear, filterId);
  //   getScienceObjectives(repYear, filterId);
  //   getScienceEngagements(repYear, filterId);
  //   getParticipantsRolesDuring(repYear, filterId);
  //   getParticipantsRolesPost(repYear, filterId);
  //   getParticipantsDemographicsDisability(repYear, filterId);
  //   getParticipantsDemographicsGender(repYear, filterId);
  //   getParticipantsDemographicsRace(repYear, filterId)

  //   getProjectProvincial(repYear, filterId);
  //   getProjectMunicipal(repYear, filterId);
  //   getParticipantsDemographicAgeRange(repYear, filterId);
  //   getParticipantsTypeDemographic(repYear, filterId);
  //   getParticipationProvincial(repYear, filterId);
  //   getParticipationMunicipal(repYear, filterId);

  //   getProjectPartnerContributions(repYear, filterId);
  //   getProjectPartnerRole(repYear, filterId);
  //   getProjectPartnerObjectives(repYear, filterId);
  //   getProjectScienceShop(repYear, filterId);
  //   getProjectFundingSources(repYear, filterId)
  //   getOrganisationalTotalProject(repYear, filterId);
  // };

  const onYearChange = (value) => {
    // let repYear = dayjs(value).format("YYYY");
    // setReportYear(repYear);
    // setcurrentDate(dayjs(value))
    setReportYear(value);
    // updateAnalytics(value, filterId);
  };

  const onScienceFieldChange = async (key) => {
    try {
      const fieldName = scienceFields.filter((value) => value.key == key);
      if (fieldName.length > 0) {
        setScienceFieldName("Science field - " + fieldName[0].value);
        getScienceDomainData(reportYear, key);
      }
    } catch (error) {
      setScienceFieldName("");
      recordError(error);
    }
  };

  const getScienceDomainData = async (year, key) => {
    try {
      const response = await citizenScienceAPI.getScienceFieldAnalytics(
        year,
        key
      );
      if (response && response.status === 200) {
        const { data } = response;
        setScienceDomains(data);
      } else {
        setScienceDomains([]);
      }
    } catch (error) {
      setScienceDomains([]);
      recordError(error);
    }
  };

  // Disable some dates on the picker based on start and end dates
  // const disabledDate = (current) => {
  //   return (
  //     current &&
  //     (current.valueOf() >= moment(endDate + 1, "YYYY") ||
  //       current.valueOf() <= moment(startDate, "YYYY"))
  //   );
  // };

  const onPageChange = (page, size) => {
    const keepCurrentPage = pageSize === size;
    const first = keepCurrentPage ? (page - 1) * pageSize : 0;
    const newPage = keepCurrentPage ? page : 1;
    setFirstRecord(first);
    setPageSize(size);
    setCurrentPage(newPage);
    setInitialKey(organisationalTotalProjects[first].key);
  };

  const handlePrint = (
    color,
    data,
    // colorField,
    type,
    desc,
    title,
    xLabel = "None",
    yLabel = "None",
    seriesField = "None",
    // isStack = false,
    stack = false,
    xField = "None",
    yField = "None"
  ) => {
    const rptProps = { ...reportOutProps };
    rptProps.color = color;
    // rptProps.colorField = colorField;
    rptProps.data = data;
    rptProps.type = type;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.description = desc;
    rptProps.title = title;
    rptProps.xLabel = xLabel;
    rptProps.yLabel = yLabel;
    // rptProps.colorField = colorField;
    rptProps.seriesField = seriesField;
    // rptProps.isStack = isStack;
    rptProps.stack = stack;
    rptProps.xField = xField;
    rptProps.yField = yField;

    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(false);
  };

  const handleGeoPrint = (title, description, data, geoType, dataSource) => {
    const rptProps = { ...reportOutProps };
    rptProps.title = title;
    rptProps.description = description;
    rptProps.color = undefined;
    rptProps.data = data;
    rptProps.type = geoType;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.dataSource = dataSource;

    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(true);
  };

  const handlePrintCancel = () => {
    setShow(false);
    setIsGeo(false);
    const rptProps = { ...reportOutProps };
    rptProps.title = "";
    rptProps.description = "";
    rptProps.color = undefined;
    // rptProps.colorField = undefined;
    rptProps.data = [];
    rptProps.type = undefined;
    rptProps.year = 0;
    rptProps.dataSource = "";
    setReportOutProps(rptProps);
  };

  const handleDataDownload = (data, filename, chartType) => {
    let csvContent;

    if (chartType === reportTypeEnum.GROUPCOL) {
      const groupedData = util.groupDataByType(data, reportYear);

      csvContent =
        "data:text/csv;charset=utf-8," +
        util.convertArrayDataToCSV(groupedData);
      DownloadDataAsExcel(groupedData, filename);
    } else {
      csvContent =
        "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
      DownloadDataAsExcel(data, filename);
    }

    //!  No longer allowing csv file download according to new requirements from business
    // const encodedURI = encodeURI(csvContent);

    //Allow the selected to be downloadable through an anchor popup
    // const link = document.createElement("a");
    // link.setAttribute("href", encodedURI);
    // link.setAttribute("download", filename);
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const selectColor = (index) => {
    if (index < 7) {
      return index;
    } else {
      return index - 7;
    }
  };

  const columns = [
    {
      title: "Host Organisation Name",
      dataIndex: "host",
      key: "host",
    },
  ];

  // Define columns for the nested table
  const expandedRowColumns = [
    {
      title: "Project Name",
      dataIndex: "projectName",
      key: "projectName",
    },
    {
      title: "Science Field",
      dataIndex: "scienceField",
      key: "scienceField",
    },
    {
      title: "Science Domain(s)",
      dataIndex: "scienceDomains",
      key: "scienceDomains",
      render: (domains) => domains.join(", "), // Join array of domains into a single string
    },
  ];

  const exportToCSV = () => {
    // Array to hold rows for CSV content
    const csvData = [
      [
        "Host Organisation Name",
        "Project Name",
        "Science Field",
        "Science Domains",
      ],
    ];

    // Check if `data` is defined and is an array
    if (Array.isArray(organisationalTotalProjects)) {
      organisationalTotalProjects.forEach((org) => {
        // Log each organisation to check data structure

        // Check if `projects` is defined and is an array
        if (Array.isArray(org.projects)) {
          org.projects.forEach((project, index) => {
            // Only include organisation name for the first project in each organisation
            csvData.push([
              index === 0 ? org.host : "", // Organisation name only for the first project
              project.projectName,
              project.scienceField,
              project.scienceDomains.join(", "),
            ]);
          });
        } else {
          console.warn(`No projects found for organisation: ${org.host}`);
        }
      });
    } else {
      console.error("Data is not an array or is undefined");
    }

    // Convert the csvData array to CSV format if it has content beyond the header row
    if (csvData.length > 1) {
      const csvContent = csvData.map((row) => row.join(",")).join("\n");

      // Create a downloadable link for CSV data
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "grouped_table_data.csv");
      link.click();
    } else {
      console.warn("No data available to export");
    }
  };

  function Tab1() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={8}>
            <Card
              title="Conceptualisation Roles"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on roles conceptualisation project">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                rolesConceptualisation.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "Conceptual",
                        rolesConceptualisation,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of citizen scientists, based on roles conceptualisation project",
                        "Citizen Scientists Roles Conceptualisation Project Distribution",
                        "Citizen Scientist Roles",
                        "No of Citizen Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        rolesConceptualisation,
                        "Citizen Scientists Roles Conceptualisation Project Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {rolesConceptualisation.length === 0 ? (
                <Empty />
              ) : (
                <Row>
                  <Col>
                    <ColumnChart
                      data={rolesConceptualisation.filter(
                        (item) => item.value > 0
                      )}
                      color="Conceptual"
                      xField="type"
                      yField="value"
                      xLabel="type"
                      yLabel="value"
                      xAxisLabel="Citizen Scientist Roles"
                      yAxisLabel="No of Citizen Scientist"
                      series="type"
                      // isStack={true}
                    />
                  </Col>
                </Row>
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="During Project"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on roles during project">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                rolesDuringData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "During",
                        rolesDuringData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of citizen scientists, based on roles during project",
                        "Citizen Scientists Roles During Project Distribution",
                        "Citizen Scientist Roles",
                        "No of Citizen Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        rolesDuringData,
                        "Citizen Scientists Roles - Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {rolesDuringData.length === 0 ? (
                <Empty />
              ) : (
                <>
                  <Row>
                    <Col>
                      <ColumnChart
                        data={rolesDuringData.filter((item) => item.value > 0)}
                        color="During"
                        xField="type"
                        yField="value"
                        xLabel="type"
                        yLabel="value"
                        xAxisLabel="Citizen Scientist Roles"
                        yAxisLabel="No of Citizen Scientists"
                        series="type"
                        // isStack={true}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="Post Project"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on roles post project">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                rolesPostData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "Post",
                        rolesPostData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of citizen scientists, based on roles post project",
                        "Citizen Scientists Roles Post Project Distribution",
                        "Citizen Scientist Roles",
                        "No of Citizen Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        rolesPostData,
                        "Citizen Scientists Roles - Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {rolesPostData.length === 0 ? (
                <Empty />
              ) : (
                <>
                  <Row>
                    <Col>
                      <ColumnChart
                        data={rolesPostData.filter((item) => item.value > 0)}
                        color="Post"
                        xField="type"
                        yField="value"
                        xLabel="type"
                        yLabel="value"
                        xAxisLabel="Citizen Scientist Roles"
                        yAxisLabel="No of Citizen Scientists"
                        series="type"
                        // isStack={true}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Card>
          </Col>
        </Row>

        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={8}>
            <Card
              title="Age Range"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on citizen scientist age range">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                ageRangeData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceBar",
                        ageRangeData,
                        reportTypeEnum.BAR,
                        "Demographic analysis of citizen scientist, based on participant age range",
                        "Citizen Scientist Age Range Distribution",
                        "Age range",
                        "No of Citizen Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        ageRangeData,
                        "Citizen Scientist Age Range Distribution",
                        reportTypeEnum.BAR
                      )
                    }
                  />,
                ]
              }
            >
              {ageRangeData?.length == 0 ? (
                <Empty />
              ) : (
                <BarChart
                  color="raceBar"
                  data={ageRangeData.filter((item) => item.value > 0)}
                  xField="type"
                  yField="value"
                  xAxisLabel="Age range"
                  yAxisLabel="No of Citizen Scientists"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="Disability"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on disability">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                disabilityData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "disabilityDoughnut",
                        disabilityData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of citizen scientists, based on disability",
                        "Citizen Scientists Disability Distribution"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        disabilityData,
                        "Citizen Scientists Disability Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {disabilityData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={disabilityData.filter((item) => item.value > 0)}
                  color="disabilityDoughnut"
                  type="Disability"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="Race"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on citizen scientist race">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                raceData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceDoughnut",
                        raceData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of citizen scientists, based on citizen scientist race",
                        "Citizen Scientists Race Distribution",
                        "Citizen Scientists per race",
                        "Percentage per citizen scientist race"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        raceData,
                        "Citizen Scientists Race Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {raceData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={raceData.filter((item) => item.value > 0)}
                  color="raceDoughnut"
                  type="Race"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Card
              title="Citizen Scientist Type"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on citizen scientist type">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                participantTypeData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "participantType",
                        participantTypeData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of citizen scientists, based on citizen scientist type",
                        "Citizen Scientists Type Distribution",
                        "Citizen Scientists type",
                        "No of Citizen Scientists"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        participantTypeData,
                        "Citizen Scientists Type Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {participantTypeData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={participantTypeData.filter((item) => item.value > 0)}
                  xLabel="type"
                  yLabel="value"
                  color="ageDougnut"
                  xAxisLabel="Citizen Scientist type"
                  yAxisLabel="No of Citizen Scientists"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Gender"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of citizen scientists, based on gender">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                genderData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "csGender",
                        genderData,
                        reportTypeEnum.PIE,
                        "Demographic analysis of citizen scientists, based on gender",
                        "Citizen Scientists Gender"
                        // "Citizen Scientists per gender",
                        // "Percentage per gender"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        genderData,
                        "Citizen Scientists Gender Groups",
                        reportTypeEnum.PIE
                      )
                    }
                  />,
                ]
              }
            >
              {genderData.length === 0 ? (
                <Empty />
              ) : (
                <PieChart
                  data={genderData.filter((item) => item.value > 0)}
                  color="csGender"
                  type="Gender"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab2() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of projects in terms of Provinces"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={projectsProvincialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                provincialProjectData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of projects in terms of Provinces",
                        projectsProvincialDistribution,
                        provincialProjectData,
                        reportTypeEnum.GEO_PROVINCES,
                        "Projects"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectsProvincialDistribution,
                        provincialProjectData,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceProvinceMap
                data={provincialProjectData}
                hoverText={projectsProvincialDistribution}
                dataSource={"Projects"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>

        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of projects in terms of Municipal boundaries"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={projectsMunicialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                municipalProjectData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of projects in terms of Municipal boundaries",
                        projectsMunicialDistribution,
                        municipalProjectData,
                        reportTypeEnum.GEO_MUNICIPALS,
                        "Projects"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        municipalProjectData,
                        projectsMunicialDistribution,
                        reportTypeEnum.GEO_MUNICIPALS
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceDistrictMap
                data={municipalProjectData}
                hoverText={projectsMunicialDistribution}
                dataSource={"Projects"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab3() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of citizen scientist in terms of Provinces"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={projectsProvincialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                provincialParticipationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of citizen scientist in terms of Provinces",
                        projectsProvincialDistribution,
                        provincialParticipationData,
                        reportTypeEnum.GEO_PROVINCES,
                        "Citizen Scientist"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectsProvincialDistribution,
                        provincialParticipationData,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceProvinceMap
                data={provincialParticipationData}
                hoverText={projectsProvincialParticipation}
                dataSource={"Participants"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
        <Row span={25} style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              style={{ height: "auto" }}
              title="Geographic distribution of citizen scientist in terms of Municipal boundaries"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={projectsMunicipalParticipation}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                municipalParticipationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of citizen scientist in terms of Municipal boundaries",
                        projectsMunicipalParticipation,
                        municipalParticipationData,
                        reportTypeEnum.GEO_MUNICIPALS,
                        "Participants"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        municipalParticipationData,
                        projectsMunicipalParticipation,
                        reportTypeEnum.GEO_MUNICIPALS
                      )
                    }
                  />,
                ]
              }
            >
              <CitizenScienceDistrictMap
                data={municipalParticipationData}
                hoverText={projectsMunicipalParticipation}
                dataSource={"Participants"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab4() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 40 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              title="Project locations"
              bordered={false}
              className="nysOrigin"
              extra={
                <Tooltip title={"Location of projects"}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                provincialParticipationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Project locations",
                        projectsProvincialDistribution,
                        provincialParticipationData,
                        reportTypeEnum.GEO_PROVINCES,
                        "Events"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        provincialParticipationData,
                        projectsProvincialDistribution,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />,
                ]
              }
            >
              <EventsMap
                data={provincialParticipationData}
                hoverText={projectsProvincialDistribution}
                dataSource={"Events"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab5() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12}>
            <Card
              title="Science Objectives"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Number of projects per objective">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                objectives.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "ageDougnut",
                        objectives,
                        reportTypeEnum.DOUGHNUT,
                        "Number of projects per objective",
                        "Science Objectives"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        objectives,
                        "Science Objectives",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {objectives.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={objectives.filter((item) => item.value > 0)}
                  color="ageDougnut"
                  type="Objectives"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Science Engagement Beneficiaries"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Number of projects per beneficiary">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                scienceEngagement.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "Science",
                        scienceEngagement,
                        reportTypeEnum.COLUMN,
                        "Science Engagement Beneficiaries.",
                        "Number of projects per beneficiary type",
                        "Beneficiaries",
                        "No of Projects",
                        "type",
                        true,
                        "year"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        scienceEngagement,
                        "Number of projects per beneficiary type",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {scienceEngagement.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={scienceEngagement.filter((item) => item.value > 0)}
                  color="Science"
                  xField="type"
                  yLabel="value"
                  xAxisLabel="Beneficiaries"
                  yAxisLabel="No of Projects"
                  series="type"
                  isStack={true}
                  yField="value"
                  xLabel="type"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  function Tab6() {
    return (
      <div className="report-content">
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12} push={0}>
            <Card
              title="Organisations Involved"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Total number of organisations and the contribuition they are providing">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                projectPartnerContributions.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "Science",
                        projectPartnerContributions,
                        reportTypeEnum.GROUPCOL,
                        "Organisations Involved.",
                        "Total number of organisations and the contribuition they are providing",
                        "Organisation Type",
                        "No of Organisations",
                        "type",
                        true,
                        "group",
                        ""
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectPartnerContributions,
                        "Number of projects per beneficiary",
                        reportTypeEnum.GROUPCOL
                      )
                    }
                  />,
                ]
              }
            >
              {projectPartnerContributions.length === 0 ? (
                <Empty />
              ) : (
                <StackColumnChart
                  color="Science"
                  data={projectPartnerContributions.filter(
                    (item) => item.value > 0
                  )}
                  xField="group"
                  // yField="type"
                  yLabel="value"
                  xAxisLabel="Organisation Type"
                  yAxisLabel="No of Organisations"
                  series="type"
                  isStack={true}
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12} push={0}>
            <Card
              title="Organisational Roles"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Participant roles per organisation type">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                projectPartnerRoles.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "OrgsRole",
                        projectPartnerRoles,
                        reportTypeEnum.GROUPCOL,
                        "Organisational Roles.",
                        "Participant roles per organisation type",
                        "Organisation Type",
                        "No of Participant roles",
                        "type",
                        true,
                        "group",
                        ""
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectPartnerRoles,
                        "Number of projects per beneficiary",
                        reportTypeEnum.GROUPCOL
                      )
                    }
                  />,
                ]
              }
            >
              {projectPartnerRoles.length === 0 ? (
                <Empty />
              ) : (
                <StackColumnChart
                  data={projectPartnerRoles.filter((item) => item.value > 0)}
                  color="OrgsRole"
                  xField="group"
                  // yField="type"
                  yLabel="value"
                  // seriesField="type"
                  xAxisLabel="Organisation Type"
                  yAxisLabel="No of Participant roles"
                  series="type"
                  isStack={true}
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12} push={0}>
            <Card
              title="Science Shops"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Total organisations of science or none science shops">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                scienceShops.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "scienceShops",
                        scienceShops,
                        reportTypeEnum.DOUGHNUT,
                        "Total organisations of science or none science shops",
                        "Science Shops"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        scienceShops,
                        "Science Shops",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {scienceShops.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart
                  data={scienceShops.filter((item) => item.value > 0)}
                  color="scienceShops"
                  type="Science Shop"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12} push={0}>
            <Card
              title={scienceFieldName}
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Total number of projects per science domain">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                scienceDomains.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "scienceFields",
                        scienceDomains,
                        reportTypeEnum.PIE,
                        "Science Domains.",
                        "Total projects per Science domain"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        scienceDomains,
                        "Number of projects per science domain",
                        reportTypeEnum.PIE
                      )
                    }
                  />,
                ]
              }
            >
              <Row>
                <Col style={{ marginLeft: "10px" }}>
                  <span>Select Science field &nbsp;</span>
                </Col>
                <Col>
                  <Select
                    style={{ width: 200, marginLeft: "10px" }}
                    onChange={onScienceFieldChange}
                    //value={scienceFields}
                  >
                    {scienceFields?.map((option) => (
                      <Option key={option.key}>{option.value}</Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              {scienceDomains.length === 0 ? (
                <Empty />
              ) : (
                <PieChart
                  data={scienceDomains.filter((item) => item.value > 0)}
                  color="scienceFields"
                  type="Science Domain"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12} push={0}>
            <Card
              title="Project objective per organisation type"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Project objective per organisation type">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                projectPartnerObjectives.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "orgObjectives",
                        projectPartnerObjectives,
                        reportTypeEnum.GROUPCOL,
                        "Project Objectives",
                        "Participant roles per organisation type",
                        "Organisation Type",
                        "No of Projects",
                        "type",
                        true,
                        "group",
                        ""
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectPartnerObjectives,
                        "Citizen Scientist Age Range Distribution",
                        reportTypeEnum.GROUPCOL
                      )
                    }
                  />,
                ]
              }
            >
              {projectPartnerObjectives.length === 0 ? (
                <Empty />
              ) : (
                <StackColumnChart
                  color="orgObjectives"
                  data={projectPartnerObjectives.filter(
                    (item) => item.value > 0
                  )}
                  xField="group"
                  // yField="type"
                  yLabel="value"
                  // seriesField="type"
                  xAxisLabel="Organisation Type"
                  yAxisLabel="No of Projects"
                  series="type"
                  isStack={true}
                />
              )}
            </Card>
          </Col>

          <Col xs={24} md={12} push={0}>
            <Card
              title="Organisation Research Dissemination Type"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Organisation type distribution by research dissemination type">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                projectPartnerResearch.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "reseach",
                        projectPartnerResearch,
                        reportTypeEnum.HEATMAP,
                        "Distribution by Organisation Research Dissemination Type",
                        "Organisation Research Dissemination Type",
                        "Project Research Type",
                        "Partner Type",
                        "group",
                        true,
                        "type",
                        "group"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        projectPartnerResearch,
                        "Distribution by Organisation Research Dissemination Type",
                        reportTypeEnum.HEATMAP
                      )
                    }
                  />,
                ]
              }
            >
              {projectPartnerResearch.length === 0 ? (
                <Empty />
              ) : (
                <HeatMapChart
                  color="reseach"
                  data={projectPartnerResearch.filter((item) => item.value > 0)}
                  xField="type"
                  yField="group"
                  xAxisLabel="Project Research Type"
                  yAxisLabel="Partner Type"
                />
              )}
            </Card>
          </Col>
        </Row>
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={24} push={0}>
            <Card
              title="Organisational Total Project"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Total projects based on organisation type">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
            >
              <Button
                onClick={exportToCSV}
                type="primary"
                style={{ marginBottom: 16 }}
              >
                Export to CSV
              </Button>
              <Table
                columns={columns}
                dataSource={organisationalTotalProjects}
                rowKey={(record) => record.key}
                expandable={{
                  expandedRowRender: (record) => (
                    <Table
                      columns={expandedRowColumns}
                      dataSource={record.projects}
                      pagination={false} // Disable pagination in the nested table
                      rowKey={(project) => project.key}
                    />
                  ),
                  rowExpandable: (record) => record.projects.length > 0, // Only expand if there are projects
                }}
                defaultExpandedRowKeys={[initialKey]} // Automatically expand the first row on page load
                // pagination={{ pageSize: 10 }}
                pagination={{
                  defaultCurrent: 1,
                  current: currentPage,
                  defaultPageSize: pageSize,
                  total: total,
                  pageSize: pageSize,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  onChange: onPageChange,
                  pageSizeOptions: [2, 5, 10, 20, 50, 100],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} ${
                      total > 1 ? "Organisations" : "Organisation"
                    }`,
                }}
                bordered
              />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  const tabList = [
    {
      key: "Participant demographic",
      label: "Demographic distribution",
      children: <Tab1 />,
      activeKey: true,
    },
    {
      key: "Project geographic",
      label: "Project geographic distribution",
      children: <Tab2 />,
    },
    {
      key: "Participant geographic",
      label: "Citizen scientists geographic distribution",
      children: <Tab3 />,
    },
    {
      key: "Science Objectives",
      label: "Science Objectives & Engagements",
      children: <Tab5 />,
    },
    {
      key: "Organisations",
      label: "Organisations",
      children: <Tab6 />,
    },
  ];

  const onTabChange = (key) => {
    switch (key) {
      case "Participant demographic":
        getParticipantsConceptRoles(reportYear, filterId);
        getParticipantsRolesDuring(reportYear, filterId);
        getParticipantsRolesPost(reportYear, filterId);
        getParticipantsDemographicsDisability(reportYear, filterId);
        getParticipantsDemographicsGender(reportYear, filterId);
        getParticipantsDemographicsRace(reportYear, filterId);
        getParticipantsDemographicAgeRange(reportYear, filterId);
        getParticipantsTypeDemographic(reportYear, filterId);
        break;
      case "Project geographic":
        getProjectProvincial(reportYear, filterId);
        getProjectMunicipal(reportYear, filterId);
        break;
      case "Participant geographic":
        getParticipationProvincial(reportYear, filterId);
        getParticipationMunicipal(reportYear, filterId);
        break;
      case "Science Objectives":
        getScienceObjectives(reportYear, filterId);
        getScienceEngagements(reportYear, filterId);
        break;
      case "Organisations":
        getProjectPartnerContributions(reportYear, filterId);
        getProjectPartnerRole(reportYear, filterId);
        getProjectPartnerResearch(reportYear, filterId);
        getProjectPartnerObjectives(reportYear, filterId);
        getProjectScienceShop(reportYear, filterId);
        getOrganisationalTotalProject(reportYear, filterId);
        getScienceFields(reportYear, filterId);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <div className="report-nys-content">
        {/* <h2 className="report-heading">{`${props.eventType} Report`}</h2> */}
        <h2 className="report-heading">Citizen Science Report</h2>
        <div className="reportYear">
          <Row
            style={{
              borderRadius: "10px",
            }}
          >
            <Col
              xs={11}
              md={11}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer" style={{
                    paddingLeft: "10px",
                  }}>
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Financial year: &nbsp;
                  {/* <DatePicker
                    picker="year"
                    onChange={onYearChange}
                    disabledDate={disabledDate}
                    defaultValue={dayjs((reportYear).toString(), monthFormat)}
                    format={monthFormat}
                    allowClear={false}
                  /> */}
                  <Select
                    // style={{ width: "65%" }}
                    placeholder="Please select financial year"
                    onChange={onYearChange}
                    loading={!financialYears.length}
                    value={reportYear}
                    size="large"
                  >
                    {financialYears?.map((year) => {
                      return (
                        <Option key={year.id} value={year.id}>
                          {year.value}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </Col>
            <Col
              xs={3}
              md={3}
              sm={3}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                ></div>
              </div>
            </Col>
          </Row>
        </div>
        <br />
      </div>
      <div className="space"></div>
      <Tabs
        type="card"
        onChange={onTabChange}
        items={tabList}
        className="report-tabs"
        key="report-tab"
      />
      <ReportTemplate
        onCancel={handlePrintCancel}
        reportOutProps={reportOutProps}
        show={show}
        key="reportTemplateEvents"
        isGeo={isGeo}
      />
    </>
  );
};
